'use strict';

function handleClickEventListener(accordionEl) {
    const titles = accordionEl.querySelectorAll(".images-accordion-title");
    const images = accordionEl.querySelectorAll(".images-accordion-image");
    const scrollCap = accordionEl.querySelector(".images-accordion-title-scroll");

    titles.forEach(title => {
        title.addEventListener("click", () => {
            const itemIndex = title.dataset.itemIndex;
            if (!itemIndex) return;

            titles.forEach(x => x.classList.remove("active"));
            title.classList.add("active");
            images.forEach(img => img.classList.toggle("active", img.dataset.itemIndex === itemIndex));

            scrollCap.scrollTo({
                top: title.offsetTop - scrollCap.offsetTop,
                behavior: "smooth"
            });
        });
    });
}

var init = function() {

    var accordionLayouts = document.querySelectorAll('.images-accordion');

    accordionLayouts.forEach(function(accordionEl) {
        handleClickEventListener(accordionEl);
    });
    
};

module.exports = {
    init: init
};